import React, { useContext } from 'react';
import * as styles from './index.module.less';
import { GOODS_TYPE } from '@/modules/pricing/utils';
import { PricingContext } from '@/modules/pricing-v2/provider';
import { OFF_TAG_CONTENT_MAP, PRICE_UNIT_PLAN_MAP } from '@/modules/pricing-v2/constants';
import OffTag from '../off-tag';

interface ICardPrice {
  price: number | string;
  monthlyPrice?: number | string;
  priceDesc: string;
  index: number;
  type: GOODS_TYPE;
  showMonthlyPrice?: boolean;
}

const CardPrice = ({ price, priceDesc, index, type, monthlyPrice, showMonthlyPrice = true }: ICardPrice) => {
  const { lang, formInfo } = useContext(PricingContext);
  const priceSymbol = PRICE_UNIT_PLAN_MAP?.[type]?.[lang];
  const offText = OFF_TAG_CONTENT_MAP?.[type]?.[lang];

  return (
    <div
      style={{
        gridArea: `p${index}`,
      }}
      className={styles.card_price}
    >
      {showMonthlyPrice && (
        <div style={{ display: 'flex', alignItems: 'center', height: '44px', gap: '4px' }}>
          {(type === GOODS_TYPE.PRO || type === GOODS_TYPE.TEAM) && formInfo.payType === 'year' && monthlyPrice && (
            <>
              <del style={{ color: '#C8CDD3', fontSize: '20px', fontWeight: 700, lineHeight: '44px' }}>
                {[GOODS_TYPE.FREE, GOODS_TYPE.PRO, GOODS_TYPE.TEAM].includes(type) && lang === 'en' && '$'}
                {monthlyPrice}
              </del>
              <del style={{ color: '#C8CDD3', fontSize: '14px', fontWeight: 700, lineHeight: '22px' }}>
                {priceSymbol}
              </del>
            </>
          )}
        </div>
      )}
      <div className={styles.price_tag_unit_container}>
        <div className={styles.price_tag_unit_container}>
          <div className={styles.price}>
            {[GOODS_TYPE.FREE, GOODS_TYPE.PRO, GOODS_TYPE.TEAM].includes(type) && lang === 'en' && '$'}
            {typeof price === 'number' ? price.toLocaleString() : price}
          </div>
          <span className={styles.tag_unit_container}>
            {lang === 'en' && formInfo.payType === 'year' && offText && (
              <OffTag className={styles.off_tag}>{offText}</OffTag>
            )}
            {priceSymbol && <span className={styles.price_unit}>{priceSymbol}</span>}
          </span>
        </div>
      </div>
      <div className={styles.price_desc}>{priceDesc}</div>
    </div>
  );
};
export default CardPrice;
